import { css } from '@eti/styles';
import { breakpoints } from '@etg/wings';
import { useMediaQuery } from 'usehooks-ts';
import { rowItemSize, resetButtonStyles } from '../../utils/styles';
import { getSeatIcon } from '../../utils/seat';
import SeatTooltip from './SeatTooltip';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const buttonStyles = css`
  cursor: pointer;
  ${resetButtonStyles};
  ${rowItemSize};
  outline: 0;
  position: relative;

  svg {
    height: 100%;
    width: 100%;
  }
`;
const initialsStyles = css`
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0.25rem;
`;
const BookableSeat = _ref => {
  let {
    isActive,
    carrier,
    column,
    row,
    onChange = () => {},
    price,
    seat,
    isSelected,
    mainCharacteristic,
    markup,
    selectedSeatInitials
  } = _ref;
  const SeatIcon = isActive ? getSeatIcon('active') : getSeatIcon(mainCharacteristic, isSelected);
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints._1170})`);
  const id = `bookableSeat-${row}-${seat}`;
  const tooltipId = id;
  const shouldShowTooltip = !isSelected || !isDesktop;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("button", {
      "aria-describedby": tooltipId,
      className: buttonStyles,
      "data-seat-id": id,
      "data-testid": id,
      "data-tooltip-id": tooltipId,
      onClick: onChange({
        price,
        carrier,
        column,
        row,
        seat,
        markup
      }),
      type: "button",
      children: [isSelected && /*#__PURE__*/_jsx("span", {
        className: initialsStyles,
        children: selectedSeatInitials
      }), /*#__PURE__*/_jsx(SeatIcon, {}), shouldShowTooltip && /*#__PURE__*/_jsx(SeatTooltip, {
        id: tooltipId,
        isDesktop: isDesktop,
        price: price,
        seat: seat
      })]
    })
  });
};
export default BookableSeat;
//# sourceMappingURL=BookableSeat.js.map